var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88093 1.68997C2.88093 2.34745 2.34794 2.88044 1.69046 2.88044C1.03299 2.88044 0.5 2.34745 0.5 1.68997C0.5 1.0325 1.03299 0.499512 1.69046 0.499512C2.34794 0.499512 2.88093 1.0325 2.88093 1.68997ZM0.499994 3.8326H2.88092V10.4992H0.499994V3.8326ZM3.83301 3.8335H6.21393V4.78661L6.26831 4.7262C7.33435 3.5417 9.2266 3.66228 10.1337 4.97251C10.3719 5.31661 10.4995 5.72519 10.4995 6.14371V10.5009H8.59479V6.86277C8.59479 6.74928 8.5765 6.63654 8.54061 6.52888L8.41338 6.14719C8.37611 6.03537 8.31331 5.93376 8.22996 5.85041C8.00622 5.62667 7.70275 5.50097 7.38632 5.50097H7.2333C7.1892 5.50097 7.1457 5.51123 7.10625 5.53096L6.98905 5.58956C6.79311 5.68753 6.62614 5.83493 6.50462 6.0172L6.21393 6.45324V10.5001H3.83301V3.8335Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSimple);
export default __webpack_public_path__ + "static/media/linkedin-simple.6132af04ff476bd3ea93297f6738e8b1.svg";
export { ForwardRef as ReactComponent };